// TT-672: Add a page to showcase YogaUI components
import React, { StrictMode } from 'react';
import { render } from 'react-dom';
import IconsList from './IconsList';
import './styles.scss';
import ButtonsList from './ButtonsList';
import TypographyList from './TypographyList';
import SpacingList from './SpacingList';
import ColorsList from './ColorsList';
import HyperLinksList from './HyperLinksList';
import FormsAndInputsList from './FormsAndInputsList';
import ShadowsList from './ShadowsList';
import AloSidebarExample from './AloSidebarExample';

const ListCollectionsYogaUI = () => {
  return (
    <div className="ListCollectionsYogaUI">
      <div className="container">
        <div>
          <h1 className="h1 center mb-md">Glow UI/Yoga UI</h1>
          <h3 className="editorial center mb-2xl">
            Design System <code className="code-example">v1.0.0</code>
          </h3>
        </div>
        <ColorsList />
        <TypographyList />
        <SpacingList />
        <ShadowsList />
        <HyperLinksList />
        <IconsList />
        <ButtonsList />
        <FormsAndInputsList />
        <AloSidebarExample />
      </div>
    </div>
  );
};

render(
  <StrictMode>
    <ListCollectionsYogaUI />
  </StrictMode>,
  document.querySelector('[react-render-target="ListCollectionYogaUI"]')
);

export default ListCollectionsYogaUI;
